import React from 'react'
import Dashnav from '../Components/Dashnav'
import AdmissionTopNotice from '../Components/AdmissionTopNotice'
import Leftmenu from '../Components/Leftmenu'
import StudentTraineeComp from './StudentTraineeComp'

function StudentTrainee() {
  return (
    <div>
      <div className='mainContainer'>
        <Leftmenu />
        <div className='theMainContainer'>
          <Dashnav />
          <AdmissionTopNotice />
          <StudentTraineeComp />
        </div>
      </div>
    </div>
  )
}

export default StudentTrainee
